import React, { Component } from "react";

class Shop extends Component {
    render() {
        return (
            <section className="section bg-light-gray" id="shop">
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-6 col-md-10">
                            <div className='block text-center mt-5 mt-lg-0'>
                                <div className="col-md-12 text-center">
                                    <h2 className="section-heading h1 text-dark mb-15">Il nostro negozio</h2>
                                    </div>
                                    <ul className="check-list mt-30">
                                        <li>Clicca sul link per <a rel="noopener noreferrer" href="https://sportinglab.it/content/34-fiorentina-baseball" target="_BLANK">Sporting Lab</a></li>
                                        <li>Inserite la Password: fiorentina23</li>
                                        <li>Scegli gli articoli che più ti interessano</li>
                                        <li>Segui le istruzioni sul sito per terminare l'acquisto</li>
                                    </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Shop;